import React from "react";
import styled from "styled-components";

import undercons from "../../../assets/maintenance.jpg";
import { ContentWrapper, ContentHeading, ContentLayout } from "../../../pages/style";
import { Typography } from "../../../ppui";
const ScreenLayout = styled.section({
  position: "relative",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
const DshboardPart = styled("div")(() => ({
  height: "50rem",
  maxWidth: "50rem",
  overflow: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& img": { width: "auto", maxWidth: "100%" },
}));

function AdminDashboard() {
  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
           Admin Dashboard
          </Typography>
        </ContentHeading>
        <ContentWrapper>
          <ScreenLayout>
            <DshboardPart>
              <img src={undercons} alt="" />
            </DshboardPart>
          </ScreenLayout>
        </ContentWrapper>
      </ContentLayout>
    </>
  );
}

export default AdminDashboard;
